import styled from "styled-components";
import { ListItem } from "../../../List";

export const LoadMore = styled(ListItem)`
  .ads-v2-listitem__title {
    color: var(--ads-v2-color-fg-subtle);
  }
`;
